import fetchPosts from "common/fetch/fetchPosts";
import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import Component from "components/templates/vn/immigration-service";

import dataJson from "./data";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="vn" page={data?.page}>
        <Component data={data} dataJson={dataJson} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "vn";
  const uri = "/immigration-service";
  const page = await fetchSeo({
    uri,
    locale,
  });

  const posts = await fetchPosts({
    postPerPage: 20,
    gqlNode: `
    categories {
      nodes {
        name
        uri
        parent {
          node {
            id
          }
        }
      }
    }`,
    locale,
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts.nodes || [],
      },
      revalidate: 1,
    },
  };
};
